import { useState } from "react";
import { useReveal } from "../../lib/useReveal";

const faqs = [
    {
        q: "Vocês atendem qualquer empresa?",
        a: "Não. A operação é seletiva por natureza. Avaliamos margem, capacidade de entrega, ticket médio e a disposição do fundador em ceder o controle do processo comercial. Cada candidatura passa por comitê interno.",
    },
    {
        q: "Vocês funcionam como agência?",
        a: "Não. Agência presta serviço. Nós assumimos canal e capital. Sem mídia avulsa, relatório ou consultoria — há receita gerada sob nossa operação.",
    },
    {
        q: "Por que vocês assumem os canais comerciais?",
        a: "Porque receita não se delega pela metade. Aquisição, abordagem, qualificação e fechamento operam sob uma única régua. A performance só existe quando responde a uma única lógica.",
    },
    {
        q: "O que acontece se o dono quiser vender junto?",
        a: "Não operamos a quatro mãos. O fundador permanece na entrega, no produto e na estratégia. O processo comercial é nosso, com critérios e cadência próprios. Sobreposição compromete o resultado.",
    },
    {
        q: "Como funciona a participação sobre receita?",
        a: "Capital de aquisição nosso. Estrutura comercial nossa. Recebemos um percentual previamente acordado sobre a receita gerada pela operação que conduzimos. Sem fee fixo. Sem mensalidade. Sem cobrança por entrega.",
    },
    {
        q: "Quais operações não recebem investimento?",
        a: "Margens apertadas. Entrega frágil. Ticket incompatível com aquisição paga. Fundador sem disposição para ceder o comercial. Ambiente operacional desalinhado. Não investimos em estrutura que não comporte volume.",
    },
    {
        q: "Existe exclusividade por segmento?",
        a: "Pode existir. A exclusividade é considerada conforme o mercado, a profundidade da operação e a capacidade de expansão dentro do nicho. Quando aplicável, integra a estrutura como proteção estratégica — não como cláusula isolada.",
    },
];

function Item({ q, a, i, open, onToggle }) {
    return (
        <div
            data-testid={`faq-item-${i}`}
            className="border-b border-white/5"
        >
            <button
                data-testid={`faq-trigger-${i}`}
                onClick={onToggle}
                className="w-full flex items-start justify-between gap-6 py-7 text-left group"
            >
                <span className="text-white font-['Outfit'] font-medium text-lg md:text-xl leading-snug pr-4 group-hover:text-[#d4af37] transition-colors">
                    {q}
                </span>
                <span
                    className={`flex-none mt-1 w-8 h-8 border border-[#d4af37]/40 flex items-center justify-center text-[#d4af37] text-lg transition-all duration-500 ${
                        open ? "rotate-45 bg-[#d4af37]/10" : ""
                    }`}
                >
                    +
                </span>
            </button>
            <div
                className={`grid transition-all duration-500 ease-out ${
                    open
                        ? "grid-rows-[1fr] opacity-100 pb-7"
                        : "grid-rows-[0fr] opacity-0"
                }`}
            >
                <div className="overflow-hidden">
                    <p className="text-white/55 leading-relaxed max-w-3xl">
                        {a}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default function FAQ() {
    const [open, setOpen] = useState(0);
    const ref = useReveal();
    return (
        <section
            data-testid="faq-section"
            id="faq"
            className="relative py-28 lg:py-40 border-t border-white/5"
        >
            <div ref={ref} className="reveal max-w-6xl mx-auto px-6 lg:px-10">
                <div className="flex items-center gap-4 mb-10">
                    <span className="h-px w-10 bg-[#d4af37]" />
                    <span className="tag-fluxo">Dúvidas Estratégicas</span>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
                    <h2 className="lg:col-span-7 font-['Outfit'] font-bold uppercase tracking-[-0.02em] text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
                        Perguntas que separam
                        <br />
                        <span className="text-gold-gradient">candidatos de parceiros</span>.
                    </h2>
                </div>

                <div className="border-t border-white/5">
                    {faqs.map((f, i) => (
                        <Item
                            key={i}
                            i={i}
                            q={f.q}
                            a={f.a}
                            open={open === i}
                            onToggle={() => setOpen(open === i ? -1 : i)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}
